import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledSuccessStep = styled.div`
  max-width: 600px;

  .ant-result {
    padding: 0 20px;
    .ant-result-icon {
      .anticon {
        font-size: 60px;
      }
    }
    .ant-result-title {
      font-size: 125%;
      margin-top: -20px;
    }
    .alert-title {
      display: flex;
      align-items: center;
      .big-text {
        margin-top: 10px;
        font-size: 116%;
        width: 100%;
        font-weight: bold;
      }
      .alert-icon {
        color: ${Colors.primary};
        font-size: 114%;
        margin-right: 10px;
      }
    }
    .credentials {
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: center;
      font-size: 16px;
      .cred-item {
        .label {
        }
        .value {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }
`;
